const moment = require('moment');

/**
 * @param {number} ageAsOf  
 * -- expected to be a 3, 4 or 8 digit number that represents a date
 * -- ie: 901, 1230, 20230101
 * 
 * @return {Date}
 */
const formatAgeAsOfNumberToDateObj = (ageAsOf) => {
  if (!ageAsOf) return null;

  const ageAsOfAsString = ageAsOf.toString();
  const numDigits = ageAsOfAsString.length;

  const dateFrom4DigitString = (digitsAsString) => 
    new Date(`${digitsAsString.slice(0, 2)}-${digitsAsString.slice(2, 4)}`);
  
  if (numDigits === 8) {
    // expects yyyymmdd, and we don't need yyyy
    return dateFrom4DigitString(ageAsOfAsString.substring(4));
  }

  if (numDigits === 4) {
    // expects that 4 digits is mmdd
    return dateFrom4DigitString(ageAsOfAsString);
  }

  if (numDigits === 3) {
    // expects that 3 digits is mdd, so add a 0 to make it mmdd
    return dateFrom4DigitString(`0${ageAsOfAsString}`);
  }

  return null;
};



/**
 * @param {string} dateString  
 * -- expected to be a string in the format 2023-06-30T00:00:00.000Z
 * 
 * @return {string}
 * -- returns a js date object
 */
const crossBrowserNewDate = (dateString) => {
  // When converting a string in the format of 2023-06-30T00:00:00.000Z to a date 
  // using new Date(), it converts to June 29th, not the 30th as expected.
  // We need to convert it to a different format in order to get the correct date.
  // We need to use moment.js to convert the date to a js date object as using new Date()
  // natively provides an invalid date in Safari.
  // This issue is explained in more detail here: https://stackoverflow.com/a/31732581
  
  if (!dateString) return null;
  if (dateString.indexOf('T') >= 0) {
    const dateOnly = dateString.split('T')[0];
    return moment(dateOnly).toDate();
  }
  return new Date(dateString);
}
 
exports.formatAgeAsOfNumberToDateObj = formatAgeAsOfNumberToDateObj;
exports.crossBrowserNewDate = crossBrowserNewDate;
